<script lang="ts">
	interface Props {
		title?: string
		videoURL?: string
		description?: string
	}

	let { title = undefined, videoURL = undefined, description = undefined }: Props = $props()

	let containerWidth: number = $state()

	let iframeWidth = $state(384)
	let iframeHeight = $state(216)

	function updateEmbedSize(contWidth: number) {
		if (!contWidth) return

		let videoWidth = (contWidth / 3) * 2

		iframeHeight = (1080 * videoWidth) / 1920
		iframeWidth = videoWidth
	}

	$effect(() => {
		updateEmbedSize(containerWidth)
	})
</script>

<div class="video-tutorial" bind:clientWidth={containerWidth}>
	{#if title}
		<h3>{title}</h3>
	{/if}
	{#if description}
		<p>{@html description}</p>
	{/if}

	{#if videoURL}
		<iframe src={videoURL} {title} width={iframeWidth} height={iframeHeight}></iframe>
	{:else}
		<p>Tutorial video coming soon!</p>
	{/if}
</div>

<style>
	.video-tutorial {
		height: fit-content;
	}

	iframe {
		border: none;
	}

	h3 {
		margin: 0;
		font-size: var(--h1);
	}

	p {
		margin-top: 1rem;
		color: var(--color-text);
	}
</style>
